__turbopack_context__.v({
  "checkbox": "Checkbox-module__dqEPpq__checkbox",
  "checked": "Checkbox-module__dqEPpq__checked",
  "input": "Checkbox-module__dqEPpq__input",
});
